import picturefill from 'picturefill';
import styles from './picture-fill-assets.module.scss';
import { resolveClassNames } from '../../../helpers/classes';

export type Props = {
  alt?: string;
  ariaLabel?: string;
  class?: string;
  className?: string;
  imgStyle?: any;
  title?: string;
  url?: string;
  url2x?: string;
};

class PictureRetinaAssets extends React.Component<Props> {
  static displayName = 'PictureRetinaAssets';

  componentDidMount() {
    picturefill();
  }

  render() {
    const { alt, ariaLabel, className, imgStyle, title, url, url2x } =
      this.props;

    const props = {
      src: url,
      className: className
        ? resolveClassNames(className, styles)
        : this.props.class,
      style: imgStyle,
      // if no alt tag is passed then we supply a null value for alt so it is
      // hidden from a screen reader
      alt: alt || '',
      title,
      srcSet: url && url2x ? `${url} 1x, ${url2x} 2x` : undefined,
      'aria-label': ariaLabel,
    } as const;

    return <img {...props} />;
  }
}

export default PictureRetinaAssets;
